import { MediaObject } from "@/ds/custom/MediaObject";
import { ProductImage } from "@/features/common/components/ProductImage";
import type { SmallProductDisplayProps } from "@/features/common/components/SmallProductDisplay";
import { EvProductName } from "@/features/ev/components/EvProductName";
import type { FC } from "react";

export type EvSmallProductDisplayProps = Omit<SmallProductDisplayProps, "imageUrl"> & {
	warning: string | null;
	productImage: string;
};

export const EvSmallProductDisplay: FC<EvSmallProductDisplayProps> = props => {
	const {
		productName,
		fcId,
		productImage,
		warning,
		onClick,
		className
	} = props;

	return (
		<MediaObject
			media={<ProductImage imageUrl={productImage} className={className} />}
			title={<EvProductName productName={productName} warning={warning} />}
			description={fcId}
			onClick={onClick} />
	);
};
